import React from "react"
import { useDisclosure } from "@mantine/hooks"
import { Popover, Tooltip } from "@mantine/core"

import { Button } from "@quorumus/plum"
import { Icon } from "@/components/Icon"

import classes from "@/components/CardSquare/AdderButton/AdderButton.module.css"

export const AdderButton = ({ adderComponent, adderType, icon, label, onClick }) => {
    const [opened, { open, toggle }] = useDisclosure(false)
    const AdderComponent = () => adderComponent

    return (
        <Popover opened={opened} onChange={toggle} position="bottom">
            <Popover.Target>
                <Tooltip label={label}>
                    <Button
                        aria-label={`Add ${label}`}
                        variant="tertiary"
                        onClick={(e) => {
                            onClick(e)
                            open()
                        }}
                    >
                        <Icon icon={icon} iconFamily="far" />
                    </Button>
                </Tooltip>
            </Popover.Target>
            <Popover.Dropdown className={classes.dropdown}>
                {adderType === label && <AdderComponent />}
            </Popover.Dropdown>
        </Popover>
    )
}
